import script from "./inviteCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./inviteCard.vue?vue&type=script&setup=true&lang=ts"

import "./inviteCard.vue?vue&type=style&index=0&id=09d0f3f0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09d0f3f0"]])

export default __exports__